export const CAMPAIGN_LEVEL_NUMBERS = Object.freeze([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
export const VISUAL_BENCHMARK_LEVEL_NUMBER = 28;

const LEVEL_URLS = Object.freeze({
  1: new URL('./levels/level-001.json', import.meta.url),
  2: new URL('./levels/level-002.json', import.meta.url),
  3: new URL('./levels/level-003.json', import.meta.url),
  4: new URL('./levels/level-004.json', import.meta.url),
  5: new URL('./levels/level-005.json', import.meta.url),
  6: new URL('./levels/level-006.json', import.meta.url),
  7: new URL('./levels/level-007.json', import.meta.url),
  8: new URL('./levels/level-008.json', import.meta.url),
  9: new URL('./levels/level-009.json', import.meta.url),
  10: new URL('./levels/level-010.json', import.meta.url),
  11: new URL('./levels/level-011.json', import.meta.url),
  12: new URL('./levels/level-012.json', import.meta.url),
  13: new URL('./levels/level-013.json', import.meta.url),
  14: new URL('./levels/level-014.json', import.meta.url),
  15: new URL('./levels/level-015.json', import.meta.url),
  16: new URL('./levels/level-016.json', import.meta.url),
  17: new URL('./levels/level-017.json', import.meta.url),
  18: new URL('./levels/level-018.json', import.meta.url),
  19: new URL('./levels/level-019.json', import.meta.url),
  20: new URL('./levels/level-020.json', import.meta.url),
  28: new URL('./levels/level-028.json', import.meta.url),
});

export function hasLevel(displayNumber) {
  return Object.hasOwn(LEVEL_URLS, Number(displayNumber));
}

export function normalizeLevelNumber(value, fallback = 1) {
  const parsed = Number.parseInt(String(value ?? ''), 10);
  return hasLevel(parsed) ? parsed : fallback;
}

export function nextCampaignLevelNumber(displayNumber) {
  const index = CAMPAIGN_LEVEL_NUMBERS.indexOf(Number(displayNumber));
  return index >= 0 && index < CAMPAIGN_LEVEL_NUMBERS.length - 1
    ? CAMPAIGN_LEVEL_NUMBERS[index + 1]
    : null;
}

export function previousCampaignLevelNumber(displayNumber) {
  const index = CAMPAIGN_LEVEL_NUMBERS.indexOf(Number(displayNumber));
  return index > 0 ? CAMPAIGN_LEVEL_NUMBERS[index - 1] : null;
}

export async function loadLevel(displayNumber) {
  const number = normalizeLevelNumber(displayNumber);
  const url = LEVEL_URLS[number];
  const response = await fetch(url, { cache: 'no-store' });
  if (!response.ok) throw new Error(`Unable to load level ${number} (${response.status})`);
  return response.json();
}

export function levelUrl(displayNumber) {
  const number = normalizeLevelNumber(displayNumber);
  return LEVEL_URLS[number];
}
